import { Search } from './../../shared/user.model';
import { Component, OnInit } from '@angular/core';
import { DISABLED } from '@angular/forms/src/model';
import { Register } from '../../shared/user.model';
import { NgForm } from '@angular/forms';
//import { UserService } from '../../shared/user.service';
import { RegistrationService } from '../../registration.service';
import { Router } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import swal from 'sweetalert2';

@Component({
  selector: 'app-ct-grid',
  templateUrl: './ct-grid.component.html',
  styleUrls: ['./ct-grid.component.css']
})
export class CtGridComponent implements OnInit {

  CorrespondanceTracking: any={}
  title = "Correspondence Tracking List";
  s: Search;
  Cvl:any;
  InwardOutwardlist: any;
  itemsPerPage: number=5;
  currentPage: number=1;
  totalItems: number;
  isSearch:boolean;
  constructor(private userService: RegistrationService, private router: Router, private errorHandler:ErrorHandler)  
  {
    this.s=new Search();
    this.isSearch = false;
   }

  ngOnInit() {
    debugger;
    //this.GetAllcasteVerificationAddedDetailsinGrid();

    this.GetAllInwardOutwardDetailsinGrid(this.itemsPerPage, 1);
    
  }

  pageChanged(pageNumber:number)
  {
    if (this.s.SearchText != "" && this.s.SearchText != null && this.s.SearchCriteria != "" && this.s.SearchCriteria != null)
    {
      this.isSearch = true;
    }
    else
    {
      this.isSearch = false;
    }
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNumber);
    else
    this.GetAllInwardOutwardDetailsinGrid(this.itemsPerPage, pageNumber);
  }
  itemsPerPageChanged(itemsPerPage: number, pageNo: number) 
  {
    if (this.s.SearchText != "" && this.s.SearchText != null && this.s.SearchCriteria != "" && this.s.SearchCriteria != null)
    {
      this.isSearch = true;
    }
    else
    {
      this.isSearch = false;
    }
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNo);
    else
      this.GetAllInwardOutwardDetailsinGrid(this.itemsPerPage, pageNo);
  }
  

  editPetition(status:string , Id :string)
  {    
    debugger;
    if (status == "Closed")
    {
      swal("Warning!", "Closed status can not be edited.", "warning");
    }
    else
    {
      this.router.navigate(['/home/correspondancetracking-form', Id,'edit']);
    }
    }
    
  

  onSearch(s,itemsPerPage: number, pageNo: number) 
  {
    var searchText = this.s.SearchText;
    var searchCriteria = this.s.SearchCriteria;
    if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
      swal("Warning!", "Please enter the search criteria and search text.", "warning");
    else {
      document.getElementById('loader-spinner').style.display = "block";
      this.userService.searchCorrespondancingTracking(searchCriteria, searchText, itemsPerPage, pageNo)
        .subscribe(
          (data:any) => {
            debugger;
            this.InwardOutwardlist = data.TrackingModel;
            this.totalItems = data.TotalItemsCount;
            this.itemsPerPage = itemsPerPage;
            this.currentPage = pageNo;
            document.getElementById('loader-spinner').style.display = "none";
          }, (error:any) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.errorHandler.HandlerError(error);
          });
    }
  }
  GetAllInwardOutwardDetailsinGrid(itemsPerPage: number, pageNo: number) {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetAllInwardOutwardDetailsinGrid(itemsPerPage, pageNo)
      .subscribe(
        (data:any) => {
          this.InwardOutwardlist= data.TrackingModel;          
          this.totalItems = data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;  
          document.getElementById('loader-spinner').style.display = "none";
        }, (error:any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }

  GetAllInwardNoToGridbySP(itemsPerPage: number, pageNo: number) {
    debugger;
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.GetAllInwardNoToGridbySP(itemsPerPage, pageNo)
      .subscribe(
        (data:any) => {
          this.InwardOutwardlist= data.TrackingModel;          
          this.totalItems = data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;  
          document.getElementById('loader-spinner').style.display = "none";
        }, (error:any) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/correspondence-tracking/ct-grid/ct-grid.component.ts